"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _redux = require("redux");

var _constants = require("settings-ui-sdk/BlogNotificationEmails/constants");

var _NotificationEmailSettings = require("../../stagedObjects/NotificationEmailSettings");

var _combineReducers;

var _default = (0, _redux.combineReducers)((_combineReducers = {}, (0, _defineProperty2.default)(_combineReducers, _constants.INSTANT_EMAIL, _NotificationEmailSettings.InstantNotificationEmailSettings.getReducer()), (0, _defineProperty2.default)(_combineReducers, _constants.DAILY_EMAIL, _NotificationEmailSettings.DailyNotificationEmailSettings.getReducer()), (0, _defineProperty2.default)(_combineReducers, _constants.WEEKLY_EMAIL, _NotificationEmailSettings.WeeklyNotificationEmailSettings.getReducer()), (0, _defineProperty2.default)(_combineReducers, _constants.MONTHLY_EMAIL, _NotificationEmailSettings.MonthlyNotificationEmailSettings.getReducer()), _combineReducers));

exports.default = _default;
module.exports = exports.default;